export const isDev = false;//!process.env.NODE_ENV || process.env.NODE_ENV === 'development';
